import React from 'react';
import styled from 'styled-components';
import { Header } from '@/features/new-landing-page/components/header';
import { Footer } from '@/features/new-landing-page/components/footer';
import { GlobalStyles } from '@/styles/globalStyles';
import { breakpoints } from '@/components/responsive';
import { FeaturesSection } from '@/features/new-landing-page/sections/features';
import { CaseStudiesSection } from '@/features/new-landing-page/sections/case-studies';
import { IntegrationsSection } from '@/features/new-landing-page/sections/integrations';
import { ReviewsSection } from '@/features/new-landing-page/sections/reviews';
import { DisruptSection } from '@/features/new-landing-page/sections/disrupt';
import { MainBannerV2Section } from '@/features/new-landing-page/sections/main-banner-v2';

export function NewHomepage() {
  return (
    <PageWrapper>
      <GlobalStyles />
      <Header />
      <MainBannerV2Section />
      <FeaturesSection />
      <CaseStudiesSection />
      <IntegrationsSection />
      <ReviewsSection />
      <DisruptSection />
      <Footer />
    </PageWrapper>
  );
}

export const PageWrapper = styled.div`
  background: #f6f5f4;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  height: 100%;
  max-width: 100vw;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: scroll;

  .btn {
    padding: 1.2rem 3.5rem;
    font-size: 1.9rem;
    border-radius: 3rem;
    font-family: Eesti, sans-serif;
    ${breakpoints.down(`md`)} {
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
    }
  }

  .small {
    ${breakpoints.down(`md`)} {
      font-size: 1.5rem !important;
      font-weight: normal;
    }
  }

  .primary-btn {
    background: #dc4949;
    border: 2px solid #dc4949;
    color: white;

    ${breakpoints.down(`md`)} {
      margin-bottom: 0.5rem;
    }
  }

  .secondary-btn {
    background: transparent;
    border: 2px solid #000000;
    color: black;

    ${breakpoints.down(`md`)} {
      border: 1px solid black;
    }
  }

  //* {
  //  z-index: 2;
  //}
`;
